export { default as EntityTypeComponent } from './EntityTypeComponent';
